export const LectureAssignmentFileIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg
      width="16"
      height="19"
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.66536 1.57861V5.02073C9.66536 5.48744 9.66536 5.7208 9.75619 5.89906C9.83609 6.05586 9.96357 6.18334 10.1204 6.26324C10.2986 6.35406 10.532 6.35406 10.9987 6.35406H14.4408M9.66536 13.854H4.66536M11.332 10.5207H4.66536M14.6654 8.01086V14.0207C14.6654 15.4208 14.6654 16.1209 14.3929 16.6556C14.1532 17.1261 13.7707 17.5085 13.3003 17.7482C12.7656 18.0207 12.0655 18.0207 10.6654 18.0207H5.33203C3.9319 18.0207 3.23183 18.0207 2.69705 17.7482C2.22665 17.5085 1.8442 17.1261 1.60451 16.6556C1.33203 16.1209 1.33203 15.4208 1.33203 14.0207V5.354C1.33203 3.95387 1.33203 3.25381 1.60451 2.71903C1.8442 2.24862 2.22665 1.86617 2.69705 1.62649C3.23183 1.354 3.9319 1.354 5.33203 1.354H8.00851C8.61999 1.354 8.92572 1.354 9.21344 1.42308C9.46853 1.48432 9.7124 1.58533 9.93608 1.7224C10.1884 1.87701 10.4046 2.0932 10.8369 2.52558L13.4938 5.18243C13.9262 5.61481 14.1424 5.831 14.297 6.08329C14.434 6.30697 14.535 6.55083 14.5963 6.80592C14.6654 7.09364 14.6654 7.39938 14.6654 8.01086Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
